<template>
  <div class="pb-5">
    <nav-bar/>
    <sidebar-toggle-button/>
    <chat-page/>
    <ticket-button/>
    
    <!-- Sidebar -->
    <div class="sidebar bg-darkgrey navbar-inverse side-box-shadow" v-if="$store.state.isSidebarOpen">
      <button id="addCustomer" class="btn btn-kne-orange col-12 mt-3" @click="add = true; setModalTitle($t('Users.addTitle'))">
        <i class="fa fa-plus-circle fa-lg" aria-hidden="true"></i>
        {{$t('Users.sidebar.add')}}
      </button>
    </div>

    <table-element
      :isShowFilter="true"
      :title="$t('Users.title')"
      :fields="fieldsObj"
      :arrOfElement="users"
      :sortSpacing="0"
      class="card mx-2 my-5"
      @updateFilterResults="updateFilterResults"
    >
      <template #header-actions>
      </template>

      <template #body-content-desktop="content">
        <!-- List of orders -->
        <tr v-for="(user, index) in content.results"
        class="table-element_hover text-center"
        :key="index">
            <td class="nowrap"><p class="table-fix-width">{{user.firstName}}</p></td>
            <td>{{user.lastName}}</td>
            <td class="nowrap"><p class="table-fix-width">{{user.email}}</p></td>
            <td>{{user.phoneNumber}}</td>
            <td>{{getRole(user.role)}}</td>
            <td>{{user.password}}</td>
            <td>
              <input @click.prevent="modifying(user); setModalTitle($t('Users.modifyTitle'))" type="button" class="btn btn-kne-orange pull-right" :value="$t('Users.modify')">
            </td>
        </tr>
      </template>

      <template #body-content-mobile="content">
        <!-- List of orders -->
        <transition-group name="fade">
          <div class="card my-3 mx-2" v-for="user in content.results" :key="user['.key']">
            <div class="card-header m-2">
              <h4>{{user.firstName}} {{user.lastName}}</h4>
              <h6><i class="fa fa-envelope mr-1"></i>{{user.email}}</h6>
            </div>
            <div class="m-2">
              <h6><i class="fa fa-phone"></i>{{user.phoneNumber}}</h6>
              <h6><i class="fa fa-users"></i>{{getRole(user.role)}}</h6>
              <h6><i class="fa fa-lock "></i>{{user.password}}</h6>
              <div id="action">
                <input @click.prevent="modifying(user); setModalTitle($t('Users.modifyTitle'))" type="button" class="btn btn-kne-orange pull-right" :value="$t('Users.modify')">
              </div>
            </div>
          </div>
        </transition-group>
      </template>
    </table-element>

    <loading-render v-if="isLoading" />

    <!-- Modal -->
    <transition name="fade">
      <modal
        :title="modalTitle"
        v-if="add || modify"
        @close-request="add = false; modify = false; clear()"
        closable
      >
        <div>
          <label class="col-12" for="firstName">{{$t('Users.firstName')}}*</label>
          <regular-input
          id="firstName"
          :value="user.firstName"
          @input="user.firstName = $event"
          type="text" :placeholder="$t('Users.firstName')" class="col-12 form-group"/>

          <label class="col-12" for="lastName">{{$t('Users.lastName')}}*</label>
          <regular-input
          id="lastName"
          :value="user.lastName"
          @input="user.lastName = $event"
          type="text" :placeholder="$t('Users.lastName')" class="col-12 form-group"/>

          <label class="col-12" for="phoneNumber">{{$t('Users.phone')}}*</label>
          <regular-input
          id="phoneNumber"
          :value="user.phoneNumber"
          @input="user.phoneNumber = $event"
          type="text" :placeholder="$t('Users.phone')" class="col-12 form-group"/>

          <label class="col-12" for="email">
            {{$t('Users.email')}}*
            <hover-tool-tip
              :text="$t('Users.modal.email_tooltip')"
              top
              right
            />
          </label>
          <regular-input
          id="email"
          :value="user.email"
          @input="user.email = $event"
          type="text" :placeholder="$t('Users.email')" class="col-12 form-group"/>

          <label class="col-12" for="password">
            {{$t('Users.password')}}*
            <hover-tool-tip
              :text="$t('Users.modal.password_tooltip')"
              top
              right
            />
          </label>
          <regular-input
          id="password"
          :value="user.password"
          @input="user.password = $event"
          type="text" :placeholder="$t('Users.password')" class="col-12 form-group"/>

          <label class="col-12" for="role">{{$t('Users.role')}}*</label>
          <regular-select
          id="role"
          :value="user.role"
          @change="user.role = $event"
          :disabled="modify && !isAdmin && user.role === 'Administrateur'"
          :placeholder="$t('Users.role')" class="col-12 form-group">
            <option :disabled="!isAdmin" value="Administrateur">{{ $t('Users.admin') }}</option>
            <option value="Chauffeur">{{ $t('Users.driver') }}</option>
            <option value="Dispatch">{{ $t('Users.dispatch') }}</option>
            <option value="Sous-traitant">{{ $t('Users.subcontractor') }}</option>
            <option value="Autre">{{ $t('Users.other') }}</option>
          </regular-select>
        </div>
        <div class="col-12">
          <p class="red-text">{{feedbackMessage}}</p>
          <button v-if="add" class="btn btn-kne-orange w-100" :disabled="!userFormCompleted" @click="addUser(user.email, user.password)">{{$t('Users.addUser')}}</button>
          <button v-else class="btn btn-kne-orange w-100" :disabled="!userFormCompleted" @click="modifyUser()">{{$t('Users.modifyUser')}}</button>
          <button v-if="modify && isAdmin" class="btn btn-danger w-100 mt-2" @click="deleteUser()">{{$t('Users.deleteTitle')}}</button>
        </div>
      </modal>
    </transition>

  </div>
</template>

<script>
import Modal from '../module/interface-components/Modal.vue'
import regularInput from '../module/basic-components/regularInput.vue'
import regularCheckbox from '../module/basic-components/regularCheckbox.vue'
import regularTextarea from '../module/basic-components/regularTextarea.vue'
import regularSelect from '../module/basic-components/regularSelect.vue'
import Search from '../module/special-components/Other-components/Search.vue'
import {db} from '../../firebase'
import _ from 'lodash'
import SidebarToggleButton from '../module/interface-components/sidebarToggleButton.vue'
import ChatPage from '../module/interface-components/ChatPage.vue'
import TicketButton from '../module/interface-components/TicketButton.vue'
import TableElement from '../module/special-components/Table-component/Table-Element.vue'
import LoadingRender from '../module/special-components/Other-components/LoadingRender.vue'
import HoverToolTip from '../module/basic-components/HoverToolTip.vue'

export default {
  name: 'Users',

  components: {
    Modal,
    regularInput,
    regularCheckbox,
    regularTextarea,
    regularSelect,
    Search,
    SidebarToggleButton,
    ChatPage,
    TicketButton,
    TableElement,
    LoadingRender,
    HoverToolTip
  },

  data () {
    return {
      modalTitle: '',
      add: false,
      modify: false,
      search: false,
      key: '',
      user: {
        firstName: '',
        lastName: '',
        phoneNumber: '',
        role: '',
        email: '',
        password: ''
      },
      provinces: ['BC', 'ON', 'NL', 'NS', 'PE', 'NB', 'QC', 'MB', 'SK', 'AB', 'NT', 'NU', 'YT'],
      fields: {
        firebase: '',
        lastName: '',
        phone: '',
        role: '',
        email: '',
        password: ''
      },
      filterResults: [],
      users: [],
      searchHistory: [],
      searchType: '',
      searchText: '',
      historyTypeTag: '',
      roles: {
        admin: {
          nameEN: 'Admin',
          nameFR: 'Administrateur',
          id: 1
        },
        dispatcher: {
          nameEN: 'Dispatcher',
          nameFR: 'Dispatch',
          id: 2
        },
        driver: {
          nameEN: 'Driver',
          nameFR: 'Chauffeur',
          id: 3
        },
        subcontractor: {
          nameEN: 'Subcontractor',
          nameFR: 'Sous-traitant',
          id: 4
        },
        boss: {
          nameEN: 'Boss',
          nameFR: 'Boss',
          id: 5
        },
        other: {
          nameEN: 'Other',
          nameFR: 'Autre',
          id: 6
        }
      },
      fieldsObj: [
        {
          text: this.$t('Users.firstName'),
          type: 'firstName',
          value: ''
        },
        {
          text: this.$t('Users.lastName'),
          type: 'lastName',
          value: ''
        },
        {
          text: this.$t('Users.email'),
          type: 'email',
          value: ''
        },
        {
          text: this.$t('Users.phone'),
          type: 'phoneNumber',
          value: ''
        },
        {
          text: this.$t('Users.role'),
          type: 'role',
          value: ''
        },
        {
          text: this.$t('Users.password'),
          type: 'password',
          value: ''
        },
        {
          text: '',
          type: '',
          value: ''
        }
      ],
      feedbackMessage: ''
    }
  },

  created () {
    this.isLoading = true
    this.$store.state.isSidebarOpen = false
    this.isScreenSmall = window.innerWidth < 800

    this.$bindAsArray('users', db.ref('userInfos').child(this.companyUID), null, () => {
      this.isLoading = false
    })
  },

  methods: {
    updateFilterResults (sortResults) {
      this.filterResults = sortResults
    },

    getRole (receivedRole) {
      const role = this.capitalizeFirstLetter(receivedRole)

      switch (role) {
        case (this.roles.admin.nameFR):
          return this.$t('Users.admin')

        case (this.roles.dispatcher.nameFR):
          return this.$t('Users.dispatch')

        case (this.roles.driver.nameFR):
          return this.$t('Users.driver')

        case (this.roles.subcontractor.nameFR):
          return this.$t('Users.subcontractor')

        case (this.roles.boss.nameFR):
          return this.$t('Users.boss')

        case (this.roles.other.nameFR):
          return this.$t('Users.other')

        default:
          console.log('Got role error. D:')
          break
      }
    },

    capitalizeFirstLetter (message) {
      message = message.charAt(0).toUpperCase() + message.slice(1)
      return message
    },

    setModalTitle (title) {
      this.modalTitle = title
    },

    addUser (email, password) {
      if (!this.checkUserInfo(email, password)) return

      window.axios.get('https://dev.transport.keepneye.com/infobemaster/decode/auth/' + this.user.email + '/' + this.user.password).then((response) => {
        // Email > 2
        // Password > 6
        db.ref('database/transporter/' + this.companyUID + '/user/employees').child(response.data.uid).child('infos').set(this.user)
        db.ref('users/deliverman').child(response.data.uid).set(this.companyUID)
        db.ref('database/transporter/' + this.companyUID + '/liste').child(response.data.uid).set(this.user.firstName + ' ' + this.user.lastName)
        if (this.user.role === 'Dispatch') {
          db.ref('users/transportersman').child(response.data.uid).set({'company': this.companyUID, 'role': 'Utilisateurs'})
        }
        // ======================== ADD CREATED USER LOG =======================
        this.$store.dispatch('newLog', {'UID': this.uid, 'action': 'ADD_USER', 'createdUserUID': response.data.uid, 'date': Date.now(), 'createdUserName': this.user.firstName + ' ' + this.user.lastName})
        // ======================== ADD CREATED USER LOG =======================

        this.clear()
        this.add = !this.add
      }).catch((error) => console.log(error))
    },

    checkUserInfo (email, password) {
      const isEmailValid = this.checkEmail(email)
      if (!isEmailValid) return
      const isPasswordValid = this.checkPassword(password)

      return (isEmailValid && isPasswordValid)
    },

    checkEmail (email) {
      if (!this.validateEmail(email)) {
        this.feedbackMessage = this.$t('Users.modal.email_invalid_format')
        return
      }

      const emailSplit = email.split('@')

      if (emailSplit[0].length < 2) {
        this.feedbackMessage = `${this.$t('Users.modal.email_feedback')} '${emailSplit[0].length}' ${this.$t('Users.modal.characters')}`
        return false
      } else {
        this.feedbackMessage = ''
        return true
      }
    },

    /** Regex of javascript email
     * @link https://www.emailregex.com/ */
    validateEmail (email) {
      if (email.match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)) return true
      else return false
    },

    checkPassword (password) {
      if (password.length < 6) {
        this.feedbackMessage = `${this.$t('Users.modal.password_feedback')} '${password.length}' ${this.$t('Users.modal.characters')}`
        return false
      } else {
        this.feedbackMessage = ''
        return true
      }
    },

    modifyUser: function () {
      db.ref('database/transporter/' + this.companyUID + '/user/employees/' + this.key + '/infos').update(this.user)
      db.ref('database/transporter/' + this.companyUID + '/liste/' + this.key).set(this.user.firstName + ' ' + this.user.lastName)
      if (this.user.role === 'Dispatch') {
        db.ref('users/transportersman').child(this.key).update({'company': this.companyUID, 'role': 'Utilisateurs'})
      } else if (this.user.role === 'Administrateur') {
        db.ref('users/transportersman').child(this.key).update({'company': this.companyUID, 'role': 'Admin'})
      } else {
        db.ref('users/transportersman').child(this.key).remove()
      }
      // ======================== ADD MODIFY USER LOG =======================
      this.$store.dispatch('newLog', {'UID': this.uid, 'action': 'MODIFY_USER', 'modifiedUserUID': this.key, 'date': Date.now(), 'modifiedUserName': this.user.firstName + ' ' + this.user.lastName})
      // ======================== ADD MODIFY USER LOG =======================
      this.modify = !this.modify
      this.clear()
    },

    deleteUser: function () {
      db.ref('database/transporter/' + this.companyUID + '/user/employees/' + this.key).remove()
      db.ref('database/transporter/' + this.companyUID + '/liste/' + this.key).remove()
      db.ref('users/deliverman').child(this.key).remove()
      db.ref('users/transportersman').child(this.key).remove()
      // ======================== ADD DELETED USER LOG =======================
      this.$store.dispatch('newLog', {'UID': this.uid, 'action': 'DELETE_USER', 'deletedUserUID': this.key, 'date': Date.now(), 'deletedUserName': this.user.firstName + ' ' + this.user.lastName})
      // ======================== ADD DELETED USER LOG =======================
      this.modify = !this.modify
      this.clear()
    },

    modifying: function (user) {
      this.modify = true

      for (var attr in this.user) {
        this.user[attr] = user[attr]
        if (user[attr] === undefined) this.user[attr] = ''
      }

      this.key = user['.key']
    },

    clear: function () {
      for (var attr in this.user) {
        this.user[attr] = ''
      }
    },

    onResize: _.debounce(function () {
      this.isScreenSmall = window.innerWidth < 800
    }, 50)
  },

  computed: {
    userFormCompleted: function () {
      if (
        this.user.firstName !== '' &&
        this.user.lastName !== '' &&
        this.user.phoneNumber !== '' &&
        this.user.role !== '' &&
        this.user.email !== '' &&
        this.user.password !== '') return true
      else return false
    },
    uid () {
      return this.$store.state.user.uid
    },
    companyUID () {
      return this.$store.state.authorization.company
    },
    isAdmin () {
      return this.$store.state.authorization.role === 'Admin'
    }
  },

  mounted () {
    this.onResize()
    window.addEventListener('resize', this.onResize, { passive: true })
  },
  beforeDestroy () {
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', this.onResize, { passive: true })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.table thead th{
  border-bottom: 1px solid #eceeef;
  border-top: none;
}
</style>
